document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-hf-tabs] .hf-tabs__tab');
  if (!btn) return;

  const wrap = btn.closest('[data-hf-tabs]');
  const id = btn.getAttribute('data-tab');

  wrap.querySelectorAll('.hf-tabs__tab').forEach(b => {
    b.classList.toggle('is-active', b === btn);
    b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
  });

  wrap.querySelectorAll('.hf-tabs__panel').forEach(p => {
    p.classList.toggle('is-active', p.getAttribute('data-panel') === id);
  });
});